import LeftDrawer from '@/components/Drawer/LeftDrawer';
import useAlchemystStoreForAi from '@/hooks/ai/client/useAlchemystStoreForAi';
import { Box, Modal, Typography } from '@mui/material';
import { usePath } from 'raviger';
import { useEffect, useState } from 'react';
import '../../globals.css';
import AlchemystSelection from '../Drawer/AlchemystSelection';

const drawerWidth = '4%';

const styles = {
  root: {
    display: 'flex',
    my: 'auto',
    mx: 'auto',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    my: 'auto',
    mx: 'auto',
    // padding: theme.spacing(3),
  },
  // toolbar: theme.mixins.toolbar,
  toolbar: {
    minWidth: '100px',
    my: 'auto',
    mx: 'auto',
  },
};

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const classes = styles;
  const currentPath = usePath();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { setStoreState, isCommandBarOpen } = useAlchemystStoreForAi(
    (store) => ({
      setStoreState: store.setStoreState,
      isCommandBarOpen: store.isCommandBarOpen,
    })
  );

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        setStoreState({ isCommandBarOpen: true });
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, []);

  return (
    <>
      {/* <NavBar /> */}
      <div style={classes.root}>
        <LeftDrawer drawerWidth={drawerWidth} />
        <main style={classes.content}>
          <div style={styles.toolbar} />
          {/* {currentPath ? <BreadcrumbsBar link={currentPath} /> : null} */}
          <div>{children}</div>
        </main>
      </div>
      <Modal
        open={isCommandBarOpen}
        onClose={() => setStoreState({ isCommandBarOpen: false })}
      >
        <Box
          px={5}
          sx={(theme) => ({
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '20vw',
            height: '40vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly',
            alignItems: 'center',
            backgroundColor: theme.palette.primary.contrastText,
            borderRadius: 2,
          })}
        >
          <Typography variant="h5">Select persona</Typography>
          <AlchemystSelection />
        </Box>
      </Modal>
    </>
  );
}
